import React, { useState } from 'react';
import {UploadFile} from "antd/es/upload/interface";
import {ClaimItem} from "../../../../../models/claims/claims";
import {createFileList} from "./file_list.factory";
import {FileUploader} from "../../../../core/file-uploader/file-uploader";
import {claimService} from "../../../../../services/claims/claims.service";
import {useRequiredStore} from "../../../../../utils/store";
import {RootStoreContext} from "../../../../../stores/root/root.store";

export interface ClaimPartsImagesProps {
    item: ClaimItem;
}

export const ClaimPartsImages: React.FC<ClaimPartsImagesProps> = ({item}) => {

    const {authStore} = useRequiredStore(RootStoreContext);
    const [fileList, setFileList] = useState<UploadFile<any>[]>(() => createFileList(item.attachments, authStore.generateUri));

    return (
        <FileUploader
            upload={file=> claimService.uploadFileForItem(item.id, file)}
            fileList={fileList}
            onFileListChanged={fileList => setFileList(fileList)}
            onRemove={file => claimService.removeFile(parseInt(file.uid))}
        />
    )
};